import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @param contentType - the type of content whose access is managed through the memberships access control component
 * @returns the i18n key for the missing publish permissions tooltip messaging
 */
export const getContentAccessControlEditPermissionsDisabledTooltipI18nKey = contentType => `contentAccessControl.disabledTooltip.noManagePermissions.${contentType}`;

/**
 * The relevant validation check outside of our library components can be made using the `isMembershipsSettingsSaveDisabledForMissingPermissions()` validation util
 *
 * @param contentType - the type of content whose access is managed through the memberships access control component
 * @returns the i18n key for the missing publish permissions tooltip messaging
 */
export const getContentAccessControlPublishPermissionsDisabledTooltipI18nKey = contentType => `contentAccessControl.disabledTooltip.noPublishPermissions.${contentType}`;

/**
 * The relevant validation check outside of our library components can be made using the `hasNoAccessGroupsSelected()` validation util
 *
 * @returns the i18n key for missing access groups selection tooltip messaging
 */
export const getHasNoAccessGroupsSelectedDisabledTooltipI18nKey = () => 'contentAccessControl.accessGroupsSelect.errors.noAccessGroupsSelected';

/**
 * @returns the i18n key for missing email send acknowledgement tooltip messaging
 */
export const getMembershipsEmailSendAcknowledgementDisabledTooltipI18nKey = () => 'contentAccessControl.accessGroupsSelect.errors.missingEmailAcknowledgement';

/**
 * The relevant validation check outside of our library components can be made using the `hasNoAccessGroupsSelected()` validation util
 *
 * @returns a <FormattedMessage /> component with the tooltip copy
 */
export const getHasNoAccessGroupsSelectedTooltipFormattedMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "contentAccessControl.accessGroupsSelect.errors.noAccessGroupsSelected"
});

// This util is used within our memberships apps
export const getAccessGroupsUsageLimitReachedTooltipFormattedMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "accessGroups.disabledTooltip.limitReached"
});